import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useState } from "react";
import QuoteDialog from "./QuoteDialog";
const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const [dialogState, setDialogState] = useState(false);
  const toggleDialog = (e) => {
    setDialogState((prev) => !prev);
  };
  const handleKeyClose = (e) => {
    if (e.key === "Escape") {
      setDialogState(false);
      document.body.style.overflow = "auto";
    }
  };
  return (
    <footer
      onKeyDown={(e) => handleKeyClose(e)}
      className="relative bg-neutral-2 pt-20 pb-4 text-white flex items-center flex-col gap-8">
      <QuoteDialog state={dialogState} toggle={toggleDialog} />
      <button
        onClick={scrollToTop}
        className="absolute bottom-4 right-4 h-8 w-8 hover:bg-primary rounded-full flex-c 
      duration-300 transition-all">
        <KeyboardArrowUpIcon fontSize="large" />
      </button>
      <div className="flex-c">
        <Link
          to={"/"}
          className="flex flex-col items-center gap-1 hover:brightness-110 transition-all">
          <img src={logo} alt="logo" width={164} />
        </Link>
      </div>
      <div className="w-fit">
        <button
          onClick={toggleDialog}
          to="/"
          className="btn border border-white whitespace-nowrap 
                  flex transition-all duration-300 items-start gap-1 text-white 
         [&>span]:hover:opacity-100 [&>span]:hover:w-4">
          Get a Quote
          <span className="opacity-0 w-0 transition-all duration-300">
            <ArrowForwardIcon />
          </span>
        </button>
      </div>
      <ul className="flex flex-col items-center gap-1 text-sm">
        <li className="flex items-center gap-1">
          <a className="hover:underline" href="tel:9412884338">
            Call US: (941) 288-4338
          </a>
        </li>
        <li className="flex items-center gap-1">
          <a
            className="hover:underline"
            href="mailto:landscapingservicesal@gmail.com">
            Email Us: landscapingservicesal@gmail.com
          </a>
        </li>
        <li className="flex items-center gap-1">
          <Link to="/" className="hover:underline">
            Find Us: North Port, Florida - 2704 Wyola Avenue
          </Link>
        </li>
      </ul>
      <ul className="flex gap-3">
        {socialLinks.map((item, index) => {
          return (
            <div
              key={index}
              className="w-12 h-12  hover:bg-white hover:text-primary rounded-full flex-c transition-all">
              <a key={index} href={item.link} className="">
                {item.icon}
              </a>
            </div>
          );
        })}
      </ul>
      <div className="div flex flex-col items-center gap-2">
        <p className="opacity-80 text-sm">
          © 2023 A&L Landscaping All Rights Reserved
        </p>
        <a
          href="https://www.thembdev.com/"
          className="flex items-center gap-2 opacity-50 hover:opacity-100 transition-all duration-300">
          <p className=" text-sm tracking-widest">
            Proudly designed and developed by
          </p>

          <img
            src="https://www.thembdev.com/static/media/mbdev_logo_sm.e00e77dcb86c64f73112577529660357.svg"
            alt="www.thembdev.com/"
            width={24}
          />
        </a>
      </div>
    </footer>
  );
};

export default Footer;
const socialLinks = [
  {
    icon: <FacebookIcon sx={{ fontSize: "2rem" }} />,
    link: "https://www.facebook.com",
  },
  {
    icon: <TwitterIcon sx={{ fontSize: "2rem" }} />,
    link: "https://www.x.com",
  },
  {
    icon: <InstagramIcon sx={{ fontSize: "2rem" }} />,
    link: "https://www.instagram.com",
  },
];
